import React from "react";
import styles from "../style.module.scss";

function endpointAnchorId(method, path) {
    return `endpoint-${method}-${path}`
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
}

export default function EndpointsList({ specs }) {
    if (!Array.isArray(specs) || specs.length === 0) return null;

    return (
        <ul className={styles.endpointsList}>
            {specs.map((spec, index) => {
                const anchorId = endpointAnchorId(spec.method, spec.path);

                return (
                    <li
                        key={`${spec.method}-${spec.path}-${index}`}
                        className={styles.endpointItem}
                    >
                        <a
                            href={`#${anchorId}`}
                            className={styles.endpointLink}
                        >
                            <span className={styles.method}>{spec.method}</span>
                            <span className={styles.path}>{spec.path}</span>
                        </a>
                    </li>
                );
            })}
        </ul>
    );
}
